import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-8" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Meine Kurse")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCourses = _resolveComponent("UserCourses")!
  const _component_AuthShroud = _resolveComponent("AuthShroud")!

  return (_openBlock(), _createBlock(_component_AuthShroud, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_UserCourses)
      ])
    ]),
    _: 1
  }))
}